import { useEffect } from "react";
import { api } from "@/lib/api";

const SESSION_KEY = "gc_visit_tracked";

export default function VisitTracker() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, "1");
    // Fire and forget — don't block render or surface errors to the user
    api.post("/track/visit").catch(() => {});
  }, []);
  return null;
}
